import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description PieChart icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { PieChart } from '@sravni/design-system-icons'
 *
 * <PieChart />
 * ```
 */
var PieChart = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "PieChart", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.5 10a7.5 7.5 0 0 1-7.5 7.5A7.5 7.5 0 0 1 2.5 10 7.5 7.5 0 0 1 10 2.5a7.5 7.5 0 0 1 7.5 7.5Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m15.303 15.303-5.059-5.059A.833.833 0 0 1 10 9.655V2.5M10.058 9.967l6.434-3.717", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { PieChart };
//# sourceMappingURL=PieChart.js.map
